import { useEffect } from "react";
import { CRM } from "@/components/atomic-crm/root/CRM";
import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";

const S5_DEAL_STAGES = [
  { value: "prospecto",    label: "Prospecto"    },
  { value: "calificado",   label: "Calificado"   },
  { value: "propuesta",    label: "Propuesta"    },
  { value: "negociacion",  label: "Negociación"  },
  { value: "won",          label: "Ganado ✓"     },
  { value: "lost",         label: "Perdido"      },
];

const S5_DEAL_CATEGORIES = [
  { value: "servicio",     label: "Servicio"         },
  { value: "consultoria",  label: "Consultoría"      },
  { value: "software",     label: "Software / SaaS"  },
  { value: "capacitacion", label: "Capacitación"     },
  { value: "otro",         label: "Otro"             },
];

const S5_TASK_TYPES = [
  { value: "llamada",      label: "Llamada"       },
  { value: "email",        label: "Email"         },
  { value: "reunion",      label: "Reunión"       },
  { value: "demo",         label: "Demo"          },
  { value: "seguimiento",  label: "Seguimiento"   },
  { value: "propuesta",    label: "Propuesta"     },
  { value: "cierre",       label: "Cierre"        },
];

const App = () => {
  // Forzar modo oscuro siempre
  useEffect(() => {
    document.documentElement.classList.remove("light");
    document.documentElement.classList.add("dark");
    localStorage.setItem("theme", "dark");
  }, []);

  // SSO: recibir sesión Supabase desde el iframe padre (app.sosbrain.com)
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== "https://app.sosbrain.com") return;
      if (event.data?.type !== "SUPABASE_SESSION") return;
      const { access_token, refresh_token } = event.data;
      getSupabaseClient()
        .auth.setSession({ access_token, refresh_token })
        .then(() => {
          // Forzar react-admin a re-evaluar auth navegando al root
          window.location.hash = "#/";
        });
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <CRM
      title="S5 · CRM"
      darkModeLogo="./logos/sosbrain-logo.png"
      lightModeLogo="./logos/sosbrain-logo.png"
      dealStages={S5_DEAL_STAGES}
      dealPipelineStatuses={["won"]}
      dealCategories={S5_DEAL_CATEGORIES}
      taskTypes={S5_TASK_TYPES}
      currency="USD"
    />
  );
};

export default App;
